export default __webpack_public_path__ + "img/dXRXWVme.64c3e7ed.svg";